import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, unref as _unref, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_4 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_5 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-primary",
  role: "alert"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  key: 2,
  type: "button",
  class: "btn btn-primary btn-lg",
  disabled: ""
}
const _hoisted_13 = {
  key: 1,
  class: "container"
}
const _hoisted_14 = ["href"]

import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    import { useSsoConfigurationQueryV1 } from '@Organizations/OrganizationUnits/queries-vue-composables'
    import { useConfigureOauth2CommandV1 } from '@Organizations/OrganizationUnits/commands-vue-composables'

    // ---------------- route ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageOrganizationSsoPage',
  setup(__props) {

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))

    // ---------------- local state ----------------

    const authMode = ref<'onlyPasswords' | 'mixed' | 'onlySso'>('onlyPasswords')

    const clientId = ref('')
    const clientSecret = ref('')
    const tokenEndpointUri = ref('')
    const authorizationEndpointUri = ref('')

    // ---------------- query ----------------

    const {
        modelSsoConfigurationQueryV1: ssoConfiguration,
        runSsoConfigurationQueryV1
    } = useSsoConfigurationQueryV1(tid)

    // ---------------- command ----------------

    const {
        invokeConfigureOauth2CommandV1,
        invokingConfigureOauth2CommandV1,
        succeedConfigureOauth2CommandV1,
        validationErrorsConfigureOauth2CommandV1
    } = useConfigureOauth2CommandV1(
        computed(() => ssoConfiguration.value?.Id),
        clientId,
        clientSecret,
        tokenEndpointUri,
        authorizationEndpointUri
    )

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Configure SSO'
        runSsoConfigurationQueryV1()
    })

    // ---------------- sync read model → form ----------------

    watch(ssoConfiguration, (cfg) =>
    {
        if (!cfg) return

        clientId.value = cfg.ClientId
        clientSecret.value = cfg.ClientSecret
        tokenEndpointUri.value = cfg.TokenEndpointUri
        authorizationEndpointUri.value = cfg.AuthorizationEndpointUri
    }, { immediate: true })

    // ---------------- derived ----------------

    const organizationId = computed(() => ssoConfiguration.value?.Id)
    const signInUrl = computed(() => ssoConfiguration.value?.SignInUrl)
    const ssoSettingsVisible = computed(() => authMode.value === 'mixed' || authMode.value === 'onlySso')
    const statusInvoking = computed(() => invokingConfigureOauth2CommandV1.value)
    const statusSucceed = computed(() => succeedConfigureOauth2CommandV1.value)
    const validationErrors = computed(() => validationErrorsConfigureOauth2CommandV1.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Configure SSO</h1></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    (!statusSucceed.value && organizationId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "onlyPasswords",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((authMode).value = $event)),
              name: "authMode",
              class: "custom-control-input",
              value: "onlyPasswords"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelRadio, authMode.value]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "onlyPasswords"
            }, "Passwords only", -1 /* CACHED */))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "mixed",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((authMode).value = $event)),
              name: "authMode",
              class: "custom-control-input",
              value: "mixed"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelRadio, authMode.value]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "mixed"
            }, "Mixed (passwords and SSO)", -1 /* CACHED */))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "onlySso",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((authMode).value = $event)),
              name: "authMode",
              class: "custom-control-input",
              value: "onlySso"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelRadio, authMode.value]
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "onlySso"
            }, "SSO only", -1 /* CACHED */))
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
            _cache[18] || (_cache[18] = _createElementVNode("div", {
              class: "alert alert-warning",
              role: "alert"
            }, " Only OAuth2 based SSO is supported. ", -1 /* CACHED */)),
            (signInUrl.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[11] || (_cache[11] = _createTextVNode(" Users can follow this link to sign in with your SSO provider:", -1 /* CACHED */)),
                  _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("a", {
                    href: signInUrl.value,
                    target: "_blank"
                  }, _toDisplayString(signInUrl.value), 9 /* TEXT, PROPS */, _hoisted_7)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_8, [
              _cache[13] || (_cache[13] = _createElementVNode("label", null, "OAuth2 client ID:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((clientId).value = $event)),
                type: "text",
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, clientId.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[14] || (_cache[14] = _createElementVNode("label", null, "OAuth2 client secret:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((clientSecret).value = $event)),
                type: "password",
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, clientSecret.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[15] || (_cache[15] = _createElementVNode("label", null, "OAuth2 token endpoint uri:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tokenEndpointUri).value = $event)),
                type: "text",
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, tokenEndpointUri.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[16] || (_cache[16] = _createElementVNode("label", null, "OAuth2 authorization endpoint uri:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((authorizationEndpointUri).value = $event)),
                type: "text",
                class: "form-control"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, authorizationEndpointUri.value]
              ])
            ]),
            (!statusInvoking.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(invokeConfigureOauth2CommandV1) && _unref(invokeConfigureOauth2CommandV1)(...args))),
                  type: "button",
                  class: "btn btn-primary btn-lg"
                }, "Save"))
              : (_openBlock(), _createElementBlock("button", _hoisted_12, "Saving..."))
          ], 512 /* NEED_PATCH */), [
            [_vShow, ssoSettingsVisible.value]
          ])
        ]))
      : (statusSucceed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _cache[19] || (_cache[19] = _createElementVNode("h4", null, "Congratulation! OAuth2 based SSO was configured.", -1 /* CACHED */)),
            _createElementVNode("a", {
              class: "btn btn-primary btn-lg",
              href: `/#/admin/organizations/dashboard/${tid.value}`,
              role: "button"
            }, "Go to dashboard", 8 /* PROPS */, _hoisted_14)
          ]))
        : _createCommentVNode("v-if", true)
  ]))
}
}

})